const formInitialData = {
  Identificacao: {
    cpfCnpj:'',
  },
  AreaDeFuncionamento: {
    fonteAbastecimentoDeAgua:"Rede Pública",
  },
  Residuos: {
    Solidos: {
      Tipos: [
        { id:2, label: 'Orgânicos', isChecked: false },
        { id:3, label: 'Recicláveis', isChecked: false },
        { id:4, label: 'Outros', isChecked: false },
      ],
      Armazenamentos: [
        { id:6, label: 'Contêiner', isChecked: false },
        { id:7, label: 'Saco de Lixo', isChecked: false },
        { id:8, label: 'Outros', isChecked: false },
      ],
      Destino: [
        { id:10, label: 'Aterro Sanitario', isChecked: false },
        { id:11, label: 'Reciclagem', isChecked: false },
        { id:12, label: 'Outros', isChecked: false },
      ]
    },
      Liquidos: {
        Tipos: [
          { id: 14, label: 'Esgoto Doméstico', isChecked: false },
          { id: 15, label: 'Água Servida (lavagem)', isChecked: false },
          { id: 16, label: 'Outros', isChecked: false },
        ],
        Tratamento: [
          { id: 18, label: 'Caixa de Gordura', isChecked: false },
          { id: 19, label: 'Sistema de Tratamento', isChecked: false },
          { id: 20, label: 'Outros', isChecked: false },
        ],
        Destino: [
          { id: 22, label: 'Rede de Esgoto', isChecked: false },
          { id: 23, label: 'Fossa Séptica', isChecked: false },
          { id: 24, label: 'Outros', isChecked: false },
        ]
      },
  },
  Poluicao: {
    Sonora: {
      Fonte: [
        { id: 26, label: 'Equipamentos Ruidosos', isChecked: false, value:'', Horarios: {inicio:"", fim:""}},
        { id: 27, label: 'Som Mecânico', isChecked: false, value:'', Horarios: {inicio:"", fim:""}},
        { id: 28, label: 'Outros', isChecked: false, value:'', Horarios: {inicio:"", fim:""}},
      ],
      Controle: [
        { id: 30, label: 'Vedação Acústica', isChecked: false },
        { id: 31, label: 'Controle de Volume', isChecked: false },
        { id: 32, label: 'Outros', isChecked: false },
      ],
    },
    Ar: {
      Origem: [
        { id: 34, label: 'Fornos (gás, lenha, etc)', isChecked: false },
        { id: 35, label: 'Poeira (material particulado)', isChecked: false },
        { id: 36, label: 'Outros', isChecked: false },
      ],
      Controle: [
        { id: 38, label: 'Filtros', isChecked: false },
        { id: 39, label: 'Exaustor com Lavador de Gases', isChecked: false },
        { id: 40, label: 'Outros', isChecked: false },
      ],
    },
  },
  Informacoes: {},
}

const form = (state = formInitialData, { type, data }) => {
  switch (type) {
    case 'ADD_TO_FORM':
      const index = Object.keys(data)[0]
      return { ...state, [index]: data[index] }
    default:
      return state
  }
}

export default form
